import * as yup from 'yup';

const SchemaInvitarNegocio = () => {
  const schema = {
    emails: yup
      .array()
      .min(1, 'Este campo es obligatorio')
      .required('Este campo es obligatorio')
  };

  return yup.object().shape(schema);
};

export { SchemaInvitarNegocio };
